import React from "react";

const EnvlopeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8421 5.4375L17.0234 12.2561L23.6738 18.9113C23.8752 18.5652 23.9991 18.1684 23.9991 17.7398V6.26133C23.9991 5.97042 23.9392 5.69475 23.8421 5.4375Z"
        fill="white"
      />
      <path
        d="M21.6551 3.90625H2.35072C1.96039 3.90625 1.59762 4.01106 1.27344 4.18033L11.5229 14.4297C11.8203 14.7271 12.3368 14.7271 12.629 14.4297L22.8302 4.23344C22.4832 4.0308 22.0851 3.90625 21.6551 3.90625Z"
        fill="white"
      />
      <path
        d="M0.196922 5.32812C0.0715781 5.61509 0 5.93066 0 6.26338V17.7419C0 18.1636 0.120609 18.5541 0.316078 18.8965L7.03828 12.1695L0.196922 5.32812Z"
        fill="white"
      />
      <path
        d="M15.9127 13.3699L13.7371 15.5508C12.8232 16.4543 11.3425 16.4691 10.4136 15.5508L8.14927 13.2812L1.5 19.9258C1.76367 20.0285 2.04797 20.0902 2.34755 20.0902H21.6519C21.9442 20.0902 22.2212 20.03 22.4796 19.9319L15.9127 13.3699Z"
        fill="white"
      />
    </svg>
  );
};

export default EnvlopeIcon;
